import { Injectable } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { Observable } from 'rxjs/Observable';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class MenuService {

    menuItems: Array<any>;

    menus: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);

    constructor(private settings: SettingsService) {}

    init(menu) {
        this.menuItems = [];
        this.addMenu(menu);
    }

    addMenu(items: Array<{
        text: string,
        heading?: boolean,
        fonctionnalite?: string,
        link?: string,     // internal route links
        elink?: string,    // used only for external links
        target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
        icon?: string,
        alert?: string,
        submenu?: Array<any>
    }>) {
        console.log('addMenu', items);
        items.forEach((item) => {
            if (this.settings.isUserMenuAllowed(item.fonctionnalite)) {
                if (item.submenu) {
                    // On ne laisse que les sous-menus pour lesquels l'utilisateur a les droits d'accès
                    const subMenuAvecDroitAcces = [];
                    item.submenu.forEach((subMenu) => {
                        if (subMenu.fonctionnalite) {
                            if (this.settings.isUserMenuAllowed(subMenu.fonctionnalite)) {
                                subMenuAvecDroitAcces.push(subMenu);
                            }
                        } else {
                            // Pas de restriction d'accès
                            subMenuAvecDroitAcces.push(subMenu);
                        }
                    });
                    item.submenu = subMenuAvecDroitAcces;
                }
               this.menuItems.push(item);
            }
        });

        this.menus.next(this.menuItems);
    }

    getMenu() {
        return this.menus;
    }

}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/core/menu/menu.service.ts